<mat-sidenav-container class="layout-container">
  <mat-sidenav #sidenav mode="over" class="side-nav">
    <div class="">
      <div class="side-logo">
        <img src="assets/kingsett-logo.svg" alt="KingSett Logo" class="logo" />
      </div>
      <mat-nav-list class="side-nav-list">
        @for (item of navItems; track $index) {
        <a mat-list-item [routerLink]="item.route" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }" (click)="sidenav.close()">
          <mat-icon>{{ item.icon }}</mat-icon>
          <span>{{ item.label }}</span>
        </a>
        }
      </mat-nav-list>
    </div>

    <div class="side-footer">
      <div class="profile-menu-wrapper" [class.active-link]="router.url === '/profile'">
        <button [disabled]="showCookieModal" class="profile-btn">
          <mat-icon>person</mat-icon>
          <span>{{ userName || 'Profile' }}</span>
        </button>
        <button [disabled]="showCookieModal" mat-icon-button [matMenuTriggerFor]="profileMenu" class="menu-icon-btn">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <button (menuOpened)="menuOpened = true" [disabled]="router.url.includes('/activity') || showCookieModal"
        #activityTrigger="matMenuTrigger" mat-button [matMenuTriggerFor]="activityMenu"
        class="activity-btn small-activity-btn" [ngClass]="{ 'activity-active': router.url.includes('/activity') }">
        <img class="filter-blue" style="height: 28px;" src="/assets/activity.svg" alt="activity">
        <span class="activity-text">Activity</span>
      </button>
      <button class="logout-btn" (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="content-wrapper">
    <mat-toolbar class="top-toolbar fixed-header">
      <div class="left-section">
        <button mat-icon-button class="hamburger" (click)="sidenav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
        <div class="logo-section">
          <img src="assets/Kingsett-logo-blue.png" alt="KingSett Logo" class="logo" />
        </div>
      </div>

      <!-- <div class="nav-links hide-on-mobile">
        @for (item of navItems; track $index) {
        <a [ngClass]="{ 'activity-active': checkActivityType(item.label) }" [routerLink]="item.route"
          routerLinkActive="active">{{ item.label }}</a>
        }
      </div> -->

      <div class="right-section">
        <!-- ── Closed message (all users, when disabled) ── -->
        @if (!isFileUploadEnabled) {
        <div class="upload-closed-msg">
          <mat-icon>error_outline</mat-icon>
          <span>The budget file upload period is now closed. Please send any revisions or new files directly to your KingSett
            property accountant.</span>
        </div>
        }
        <!-- ── File Upload Toggle (Admin only) ── -->
        @if (userRole === 'Administrator') {
        <div class="file-upload-toggle">
          <span class="toggle-label">File Upload</span>
          <mat-slide-toggle [checked]="isFileUploadEnabled" (change)="toggleFileUpload()" color="primary">
          </mat-slide-toggle>
        </div>
        }        
        
        <button mat-button [matMenuTriggerFor]="profileMenu" class="profile-btn">
          <mat-icon class="profile-icon">person</mat-icon>
          <span class="name-arrow">
            <span>{{ userName || 'Profile' }}</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </span>
        </button>
        <button (menuOpened)="menuOpened = true" [disabled]="router.url.includes('/activity') || showCookieModal"
          #activityTrigger="matMenuTrigger" mat-button [matMenuTriggerFor]="activityMenu" class="activity-btn"
          [ngClass]="{ 'activity-active': router.url.includes('/activity') }">
          <img style="height: 28px;" src="/assets/activity.svg" alt="activity">
        </button>
        <button mat-button class="logout-btn" (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </div>
    </mat-toolbar>

    <nav class="sub-nav hide-on-mobile">
      @for (item of navItems; track $index) {
      <a [ngClass]="{ 'activity-active': checkActivityType(item.label) }" [routerLink]="item.route"
        routerLinkActive="active">{{ item.label }}</a>
      }
    </nav>

    <mat-menu #profileMenu="matMenu" class="profile-menu">
      <!-- Actionable items -->
      <a [class.disabled]="showCookieModal" mat-menu-item [routerLink]="'/profile'" (click)="onProfileMenuClick(sidenav)">
        <mat-icon>account_circle</mat-icon>
        <span>Profile</span>
      </a>
      @if (canChangePassword()) {
        <button [disabled]="showCookieModal" mat-menu-item (click)="openChangePassword(sidenav)">
          <mat-icon>lock</mat-icon>
          <span>Change Password</span>
        </button>
      }
    </mat-menu>
    <mat-menu (closed)="menuOpened = false" #activityMenu="matMenu" class="activity-menu">
      @if (menuOpened) {
        <ng-container>
          <app-activity-list [showViewAll]="true" [enableLoadMore]="false" [menu]="true" [triggerRef]="activityTrigger">
          </app-activity-list>
        </ng-container>
      }
    </mat-menu>


    <main class="layout-content">
      <router-outlet></router-outlet>
      <app-footer class="fixed-footer"></app-footer>
    </main>

  </mat-sidenav-content>
</mat-sidenav-container>

<!-- cookie consent modal -->

@if(showCookieModal && !this.router.url.includes('/cookie-policy') && !this.router.url.includes('/privacy-policy')) {
  <div class="cookie-modal">
  <div class="cookie-content">

    <h2>Cookie & Local Storage Consent</h2>

    <p>
      We use cookies and browser local storage to store essential data such as:
    </p>
    <ul>
      <li>Authentication tokens used to keep you securely signed in</li>
      <li>Your user preferences to personalize your experience</li>
      <li>Session information required to maintain and improve site functionality</li>
    </ul>

    <p>
      For more details, read our 
      <a [routerLink]="'/cookie-policy'">Cookie Policy</a> and 
      <!-- <a [routerLink]="'/privacy-policy'">Privacy Policy</a>. -->
      <a href="https://www.kingsettcapital.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
    </p>

    <button class="accept-btn" mat-raised-button (click)="updateCookieConsent()">
      Accept
    </button>

  </div>
</div>
}
